export const ARTICLE_DETAIL_FETCH = 'ARTICLE_DETAIL_FETCH';
export const ARTICLE_DETAIL_SUCCESS = 'ARTICLE_DETAIL_SUCCESS';
export const ARTICLE_DETAIL_FAILURE = 'ARTICLE_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ArticleDetail/actionTypes.js